const SetupCardBodyInfo = ({
  label,
  info,
  moreInfoCount,
}: {
  label: string;
  info: string | number | null;
  moreInfoCount?: number;
}) => {
  // rendering setup card body info component here
  return (
    <div className='flex items-start gap-1 text-legal-dark-blue italic'>
      <p className='capitalize text-nowrap'>{label}</p>
      <p>:</p>
      <p className='font-semibold'>
        {info || 'N/A'}
        {moreInfoCount && (
          <span className='font-normal text-base-orange'>
            {' '}
            ...+{moreInfoCount} More
          </span>
        )}
      </p>
    </div>
  );
};

export default SetupCardBodyInfo;
